import { useEffect, useRef, useState } from "react";

type Handler = () => void;

// Hook to simplify timeouts in functional components
export const useTimeout = (handler: Handler, timeoutMs: number): void => {
    // Create a ref that stores handler
    const savedHandler = useRef<Handler>(undefined);

    // Update ref.current value if handler changes.
    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    // Set up timer
    useEffect(() => {
        const timeoutID = window.setTimeout(() => {
            savedHandler.current?.();
        }, timeoutMs);
        return () => clearTimeout(timeoutID);
    }, [timeoutMs]);
};

// Hook to simplify intervals in functional components
export const useInterval = (handler: Handler, intervalMs: number): void => {
    // Create a ref that stores handler
    const savedHandler = useRef<Handler>(undefined);

    // Update ref.current value if handler changes.
    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    // Set up timer
    useEffect(() => {
        const intervalID = window.setInterval(() => {
            savedHandler.current?.();
        }, intervalMs);
        return () => clearInterval(intervalID);
    }, [intervalMs]);
};

// Hook to simplify a variable counting down to 0, handler called when it reached 0
export const useExpiringCounter = (handler: Handler, intervalMs: number, initialCount: number): number => {
    const [count, setCount] = useState(initialCount);
    //Pas: usiamo useRef per salvare il handler perché se usassimo una variabile normale, 
    // il suo valore non sarebbe mantenuto tra le chiamate del handler.
    // In questo modo, si evitano sideEffect indesiderati dovuti alla chiusura del valore del handler in un momento specifico.
    const savedHandler = useRef<Handler>(handler);
    
    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    useInterval(() => setCount((c) => c - 1), intervalMs);
    
    useEffect(() => {
        if (count === 0) {
            savedHandler.current();
        }
    }, [count]);

    return count;
};
